import { useNavigate } from 'react-router-dom';

export default function LeagueCard({ league }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/leagues/${league.id}`)}
      className="bg-surface-container rounded-xl p-5 cursor-pointer hover:bg-surface-container-high hover:border-primary/30 transition-all duration-200 group border border-outline-variant/20 active:scale-[0.99]"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <h3 className="font-headline font-bold text-on-surface group-hover:text-primary transition-colors">
          {league.name}
        </h3>
        <span className="material-symbols-outlined shrink-0 text-on-surface-variant group-hover:text-primary group-hover:translate-x-1 transition-all duration-200">
          chevron_right
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        <span className="px-2 py-1 bg-primary/10 text-primary border border-primary/20 text-[10px] font-label font-semibold rounded-full uppercase tracking-[0.12em]">
          {league.region_name}
        </span>
        <span className="px-2 py-1 bg-secondary/10 text-secondary border border-secondary/20 text-[10px] font-label font-semibold rounded-full uppercase tracking-[0.12em]">
          Step {league.step_number}
        </span>
      </div>
    </div>
  );
}
